import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29ff7be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-manager" }
const _hoisted_2 = {
  key: 0,
  class: "owner-area"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Profile owner")
], -1))
const _hoisted_5 = { class: "owner-actions" }
const _hoisted_6 = {
  key: 0,
  type: "button",
  class: "btn btn-inline btn-link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#transferModal"
}
const _hoisted_7 = {
  key: 1,
  type: "button",
  class: "btn btn-inline btn-link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#requestTransferModal"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Linked to tree profile ", -1))
const _hoisted_10 = {
  key: 0,
  type: "button",
  class: "btn btn-inline btn-link action",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmUnlinkModal"
}
const _hoisted_11 = {
  key: 2,
  class: "child-option"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Profile options ", -1))
const _hoisted_13 = { class: "form-check" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "childOption",
  class: "form-check-label"
}, " This person is a child ", -1))
const _hoisted_16 = {
  key: 0,
  class: "help-text"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Last modified ", -1))
const _hoisted_18 = { class: "input-value" }
const _hoisted_19 = { class: "status" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Processing status ", -1))
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = {
  key: 0,
  type: "button",
  class: "btn btn-inline btn-link btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmCleanModal"
}
const _hoisted_23 = {
  key: 1,
  type: "button",
  class: "btn btn-danger btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmDeleteModal"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Unlinking this profile will allow it to be edited. It will no longer be updated automatically when the matching tree profile changes. ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "This operation cannot be undone.")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Do you want to continue? ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " This will delete data that was added to this profile at some point but is no longer referenced. ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " All information in this profile will be permanently deleted. ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Do you want to continue? ", -1))

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useUserStore } from '@/gp/UserStore'
import { useGroupStore } from '@/rd/GroupStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { useTrackingLinkStore } from '@/rd/TrackingLinkStore'
import { ItemType } from '@/rd/ResearchDataModel'
import { useTokenManager } from '@/auth/TokenManager'
import { DataGroupType, ItemPermissions } from '@/gp/GroupAdminModel'
import { ProfileType, ProfileUtils } from './ProfileUtils'
import { CompositeId } from '@/rd/CompositeId'
import { PatchChange } from '@/util/Api'
import { LoadMode } from '@/util/AsyncData'
import { DownloadIcon, Trash2Icon, StarIcon } from '@zhuowenli/vue-feather-icons'
import { refThrottled } from '@vueuse/core'
import UserItem from '@/manage/users/UserItem.vue'
import ProfileCard from '@/manage/ProfileCard.vue'
import InfoButton from '@/util/InfoButton.vue'
import Modal from '@/util/Modal.vue'
import UserAddModal from '@/manage/users/UserAddModal.vue'
import RelativeDate from '@/util/RelativeDate.vue'
import DataGroupTransferModal from '../datagroups/DataGroupTransferModal.vue'
import DataGroupRequestTransferModal from '../datagroups/DataGroupRequestTransferModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileManager',
  props: {
    personId: {}
  },
  setup(__props: any) {

const props = __props;



const isChildRef = ref(false)
const showChildOptionInfoRef = ref(false)

const confirmUnlinkModalRef = ref<InstanceType<typeof Modal>>()
const userAddModalRef = ref<InstanceType<typeof UserAddModal>>()
const confirmCleanModalRef = ref<InstanceType<typeof Modal>>()
const confirmDeleteModalRef = ref<InstanceType<typeof Modal>>()

const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const userStore = useUserStore()
const groupStore = useGroupStore()
const personStore = usePersonStore()
const workspaceStore = useWorkspaceStore()
const trackingLinkStore = useTrackingLinkStore()
const router = useRouter()
const tokenManager = useTokenManager()

// Async data
const groupIdRef = computed(() => CompositeId.getGroupId(props.personId))
const asyncDataGroupRef = computed(() => dataGroupStore.getAsyncGroup(groupIdRef.value, LoadMode.EnsureLoaded))
const asyncDataGroupMemberKeysRef = computed(() => dataGroupMemberStore.getAsyncKeyListsForDataGroups([groupIdRef.value], LoadMode.EnsureLoaded).at(0))
const asyncPermissionsRef = computed(() => dataGroupStore.getAsyncPermissions(groupIdRef.value, LoadMode.EnsureLoaded))
const asyncGroupRef = computed(() => groupStore.getAsyncGroupList([groupIdRef.value], LoadMode.EnsureLoaded).at(0))
const asyncPersonRef = computed(() => personStore.getAsyncPerson(props.personId, LoadMode.EnsureLoaded))
const asyncWorkspaceRef = computed(() => workspaceStore.getAsyncWorkspacesForGroups([groupIdRef.value], LoadMode.EnsureLoaded).at(0))
const asyncTrackedItemLinkRef = computed(() => trackingLinkStore.getAsyncTrackingLink(ItemType.Person, props.personId, LoadMode.EnsureLoaded))

// Loaded data
const personRef = computed(() => asyncPersonRef.value?.data)
const dataGroupRef = computed(() => asyncDataGroupRef.value?.data)
const ownerRef = computed(() => userStore.getLoadedUser(dataGroupRef.value?.ownerId)) // loaded with group
const groupRef = computed(() => asyncGroupRef.value?.data)
const workspaceRef = computed(() => asyncWorkspaceRef.value?.data)

// Computed data
const groupStatusRef = computed(() => groupRef.value?.status)
const slowGroupStatusRef = refThrottled(groupStatusRef, 1000, true, true)
const trackedPersonIdRef = computed(() => asyncTrackedItemLinkRef.value?.data?.trackedItemId)
const profileTypeRef = computed(() => ProfileUtils.getProfileType(personRef.value, dataGroupRef.value, ownerRef.value))
const permissionsRef = computed(() => asyncPermissionsRef.value?.data ?? ItemPermissions.None)
const isOwnerRef = computed(() => (permissionsRef.value & ItemPermissions.Owner) > 0)
const canEditRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) > 0)
const canTransferRef = computed(() => isOwnerRef.value && profileTypeRef.value != ProfileType.User && !tokenManager.current.isSupervised)
const canRequestTransferRef = computed(() => !isOwnerRef.value && profileTypeRef.value != ProfileType.User && !tokenManager.current.isSupervised)
const canReprocessRef = computed(() => canEditRef.value && groupRef.value?.profile)
const canDeleteRef = computed(() => (permissionsRef.value & ItemPermissions.Delete) > 0 && profileTypeRef.value != ProfileType.User)

const showAddUserRef = computed(() => isOwnerRef.value && profileTypeRef.value == ProfileType.Managed && dataGroupRef.value?.isChild)
const isResearchRef = computed(() => dataGroupRef.value?.groupType == DataGroupType.Research)
const showIsChildRef = computed(() => profileTypeRef.value == ProfileType.Managed || profileTypeRef.value == ProfileType.User)

watch(() => props.personId, () => {
  isChildRef.value = dataGroupRef.value?.isChild ?? false // loaded with page data
  showChildOptionInfoRef.value = false
}, { immediate: true })

watch(isChildRef, async () => {
  if (dataGroupRef.value && isChildRef.value != dataGroupRef.value.isChild) {
    const change = new PatchChange('/isChild', isChildRef.value)
    await dataGroupStore.patchAsync(dataGroupRef.value!.id!, [change])
  }
})

async function onCreateTrackingProfile() {
  alert("track me!")
}

async function unlinkProfile() {
  await dataGroupStore.unlinkAsync(dataGroupRef.value!.id!)
  confirmUnlinkModalRef.value?.close()
}

async function reprocessAsync() {
  await groupStore.reprocessAsync(dataGroupRef.value!.id!, true)
}

async function downloadAsync() {
  const blob = new Blob([await groupStore.getGroupDataAsync(dataGroupRef.value!.id!)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  window.open(url)
}

async function cleanAsync() {
  try {
    await groupStore.cleanAsync(dataGroupRef.value!.id!)
    confirmCleanModalRef.value?.close()
  }
  finally {
    confirmCleanModalRef.value?.reset()
  }
}

async function deleteProfile() {
  await dataGroupStore.deleteAsync(dataGroupRef.value!.id!)
  confirmDeleteModalRef.value?.close()
  router.push('/profiles')
}

function onAddChildUser() {
  userAddModalRef.value?.open(props.personId!)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isResearchRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (profileTypeRef.value == _unref(ProfileType).User)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This is the owner's personal profile. "))
            : _createCommentVNode("", true),
          _hoisted_4,
          _createVNode(UserItem, {
            "user-id": dataGroupRef.value?.ownerId
          }, null, 8, ["user-id"]),
          _createElementVNode("div", _hoisted_5, [
            (canTransferRef.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_6, " Change "))
              : _createCommentVNode("", true),
            (canRequestTransferRef.value)
              ? (_openBlock(), _createElementBlock("button", _hoisted_7, " Change "))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (profileTypeRef.value == _unref(ProfileType).ManagedLinked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(ProfileCard, { "person-id": trackedPersonIdRef.value }, null, 8, ["person-id"]),
          (canEditRef.value)
            ? (_openBlock(), _createElementBlock("button", _hoisted_10, " Unlink "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (showIsChildRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "childOption",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChildRef).value = $event)),
              disabled: !canEditRef.value
            }, null, 8, _hoisted_14), [
              [_vModelCheckbox, isChildRef.value]
            ]),
            _hoisted_15,
            _createVNode(InfoButton, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showChildOptionInfoRef.value = !showChildOptionInfoRef.value))
            })
          ]),
          (showChildOptionInfoRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Use this option to enable special features for children under age 13 that help protect them and their information. "))
            : _createCommentVNode("", true),
          (showAddUserRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary",
                onClick: onAddChildUser
              }, " Create child account "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(RelativeDate, {
          value: groupRef.value?.dataModifiedDate
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: _normalizeClass(["badge", _unref(slowGroupStatusRef)])
        }, _toDisplayString(_unref(slowGroupStatusRef)), 3),
        (canReprocessRef.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-inline btn-link btn-sm",
              onClick: reprocessAsync
            }, " Reprocess "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (canEditRef.value)
        ? (_openBlock(), _createElementBlock("button", _hoisted_22, " Remove unused data "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-inline btn-link btn-sm",
        onClick: downloadAsync
      }, [
        _createVNode(_unref(DownloadIcon)),
        _createTextVNode(" Download (JSON) ")
      ]),
      (canDeleteRef.value)
        ? (_openBlock(), _createElementBlock("button", _hoisted_23, [
            _createVNode(_unref(Trash2Icon)),
            _createTextVNode(" Delete profile ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Modal, {
      id: "confirmUnlinkModal",
      ref_key: "confirmUnlinkModalRef",
      ref: confirmUnlinkModalRef,
      "ok-style": "warning",
      onOk: unlinkProfile
    }, {
      title: _withCtx(() => [
        _createTextVNode("Unlink profile")
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Unlink")
      ]),
      busyText: _withCtx(() => [
        _createTextVNode("Unlinking...")
      ]),
      default: _withCtx(() => [
        _hoisted_24,
        _hoisted_25,
        _hoisted_26
      ]),
      _: 1
    }, 512),
    _createVNode(UserAddModal, {
      ref_key: "userAddModalRef",
      ref: userAddModalRef
    }, null, 512),
    _createVNode(Modal, {
      id: "confirmCleanModal",
      ref_key: "confirmCleanModalRef",
      ref: confirmCleanModalRef,
      "ok-style": "warning",
      onOk: cleanAsync
    }, {
      title: _withCtx(() => [
        _createTextVNode("Remove unused data")
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Remove unused")
      ]),
      default: _withCtx(() => [
        _hoisted_27
      ]),
      _: 1
    }, 512),
    _createVNode(Modal, {
      id: "confirmDeleteModal",
      ref_key: "confirmDeleteModalRef",
      ref: confirmDeleteModalRef,
      "ok-style": "danger",
      onOk: deleteProfile
    }, {
      title: _withCtx(() => [
        _createTextVNode("Delete profile")
      ]),
      okIcon: _withCtx(() => [
        _createVNode(_unref(Trash2Icon))
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Delete")
      ]),
      busyText: _withCtx(() => [
        _createTextVNode("Deleting...")
      ]),
      default: _withCtx(() => [
        _hoisted_28,
        _hoisted_29
      ]),
      _: 1
    }, 512),
    _createVNode(DataGroupTransferModal, {
      id: "transferModal",
      "data-group-id": dataGroupRef.value?.id
    }, null, 8, ["data-group-id"]),
    _createVNode(DataGroupRequestTransferModal, {
      id: "requestTransferModal",
      "data-group-id": dataGroupRef.value?.id
    }, null, 8, ["data-group-id"])
  ]))
}
}

})